import React from 'react';
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"

export default function Sidebar() {

	const data = useStaticQuery(graphql`
		query getAllCategories {
			allCategories:allWpCategory(
		  filter: {parentId: {eq: null}, slug: {nin: ["faq", "blog", "poker-rules", "uncategorized"]}}
		) {
			categories: nodes {
			id
			name
			slug
			uri
		  }
		}
	  }
	`);
	
	const categories = data.allCategories.categories;

	return (
		<div className="sidenav">
			<div className="widget" id="widgetlinks">

				<div id="sidebar-menu-widget" className="widget-inner">
					<h4>Menu</h4> 
					<ul>
						<li>
							<Link to={`/house-rules`} className='sidebar-links' activeClassName="active">House Rules </Link>
						</li>
						<li>
							<Link to={`/poker-rules`} className='sidebar-links' activeClassName="active">Poker Game Rules </Link>
						</li>
						<li>
							<Link to={`/hand-rankings`} className='sidebar-links' activeClassName="active">Hand Rankings</Link>
						</li>
						<li>
							<Link to={`/game-betting-styles`} className='sidebar-links' activeClassName="active">Game & Betting Styles </Link>
						</li>
						<li>
							<Link to={`/faq`} className='sidebar-links' activeClassName="active">FAQ </Link>
						</li>
						<li>
							<Link to={`/promotions`} className='sidebar-links' activeClassName="active">Promotions</Link>
						</li>
						<li>
							<Link to={`/updates`} className='sidebar-links' activeClassName="active">Updates</Link>
						</li>					
						<li>
							<Link to={`/download`} className='sidebar-links' activeClassName="active">Download</Link>
						</li>
						<li>
							<a href="https://play.swcpoker.club" className='sidebar-links'>Play Now </a>
						</li>
					</ul>
				</div>	

				<ul id="categories-list" className='widget-inner'>
					<h4>CATEGORIES</h4>

					{
						categories.map((category, i) => {
							return (
								<li key={i}>
									<Link to={`${category.uri}`} key={category.id} className='sidebar-links' activeClassName="active">{category.name}</Link>
								</li>
							);
						})
					}
				</ul>
			</div>

		</div>
	)
}



